import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Popup } from 'semantic-ui-react';
import DateComponent from "../../../common/Date";
import RadioButtonGroup from "../../../common/RadioButtonGroup";
import RelativeLink from "../../../common/RelativeLink";
import TextAreaInput from "../../../common/TextAreaInput";

const TochtenRows = (props) => {
	const {
		tochten,
		onChangeRedenVanAfkeuring,
		onChangeGoedkeuren,
		errors,
		validationMessageType
	} = props;

	function handleOnChangeRedenVanAfkeuren(tochtId) {
		return function (event) {
			onChangeRedenVanAfkeuring(tochtId, event);
		};
	}

	function handleOnChangeGoedkeuren(i) {
		return function (event) {
			onChangeGoedkeuren(i, event);
		};
	}

	return tochten.map((tocht, i) => {
		const radiobuttonItems = [{ value: true, label: 'Ja' }, { value: false, label: 'Nee' }, { value: 'null', label: 'Onbeslist' }];
		return (
			<Fragment key={"fragment_tocht_" + i}>
				<tr key={i} height="80">
					<td>{tocht.organisatorNaam}</td>
					<td><DateComponent value={tocht.datum} /></td>
					<td>{tocht.startgemeenteNaam}</td>
					<td ><RadioButtonGroup
						key={"goedgekeurd_" + i}
						label=""
						name={"goedgekeurd_" + i}
						labelInside
						value={tocht.goedgekeurd}
						onChange={handleOnChangeGoedkeuren(i)}
						size={12}
						horizontal
						noBorder
						items={radiobuttonItems}
					/></td>
					<td>{tocht.redenVanAfkeuring && tocht.redenVanAfkeuring.length > 30 ?
						<Popup wide="very" position="top left" trigger={<p>{tocht.redenVanAfkeuring.substring(0, 30) + "..."}</p>} content={tocht.redenVanAfkeuring} />
						: tocht.redenVanAfkeuring}
					</td>
					<td><RelativeLink to={"/e-loket/organisator/" + tocht.id + "/goedkeuren" + "/false"} title="detail tocht"><i className="fa fa-file-text-o fa-fw"></i></RelativeLink></td>
				</tr>
				{
					(tocht.goedgekeurd === false || tocht.goedgekeurd === "false") ?
						<tr>
							<td colSpan="6">
								<TextAreaInput
									size={12}
									height={3}
									label="Geef hier de reden voor de afkeuring (max 500 tekens)"
									name={"redenVanAfkeuring_" + tocht.id}
									key={"redenVanAfkeuring_" + tocht.id}
									value={tocht.redenVanAfkeuringEdited}
									onChange={handleOnChangeRedenVanAfkeuren(tocht.id)}
									maxLength={500}
									validationMessage={errors ? errors["redenVanAfkeuring_" + tocht.id] : ""}
									validationMessageType={validationMessageType}
								/>
							</td>
						</tr>
						: null
				}
			</Fragment >
		);
	});
};

TochtenRows.propTypes = {
	tochten: PropTypes.array.isRequired,
	onChangeRedenVanAfkeuring: PropTypes.func.isRequired,
	onChangeGoedkeuren: PropTypes.func.isRequired,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string
};

export default TochtenRows;
